/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IObrienReturnFormData } from './obrien-return-form.data';
import { IObrienReturnFormProps } from './obrien-return-form.props.autogenerated';

export interface IObrienReturnFormViewProps extends IObrienReturnFormProps<IObrienReturnFormData> {

}

/**
 *
 * ObrienReturnForm component
 * @extends {React.PureComponent<IObrienReturnFormProps<IObrienReturnFormData>>}
 */
class ObrienReturnForm extends React.PureComponent<IObrienReturnFormProps<IObrienReturnFormData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default ObrienReturnForm;
